import {
  TelegramIcon,
  VKIcon,
  MaxIcon,
  WhatsAppIcon,
  ViberIcon,
  OKIcon,
  InstagramIcon
} from 'widget/shared/icons/channel';
import { BaseIconProps } from 'widget/shared/icons/BaseIcon';
import { WidgetChannelKind } from 'widget/entities/channel';

export const ChannelsConfig: Record<
  WidgetChannelKind,
  React.ComponentType<BaseIconProps>
> = {
  [WidgetChannelKind.vk]: VKIcon,
  [WidgetChannelKind.tg]: TelegramIcon,
  [WidgetChannelKind.max]: MaxIcon,
  [WidgetChannelKind.wa]: WhatsAppIcon,
  [WidgetChannelKind.vb]: ViberIcon,
  [WidgetChannelKind.ok]: OKIcon,
  [WidgetChannelKind.ig]: InstagramIcon
};
